
export const CATEGORY_COLORS = [
  { bg: "#3F51B5", text: "#ffffff" },
  { bg: "#E91E63", text: "#ffffff" },
  { bg: "#009688", text: "#ffffff" },
  { bg: "#FF5722", text: "#ffffff" },
  { bg: "#673AB7", text: "#ffffff" },
];

export const BENEFIT_ROWS = [
  { key: "videos", label: "Videos" },
  { key: "collateral", label: "Collateral" },
  { key: "leadScanning", label: "Lead Scanning" },
  { key: "promotionalBanner", label: "Promotional Banner" },
  { key: "inquiries", label: "Inquiries" },
];

export const defaultBenefits = () => ({
  exhibitorPasses: { enabled: true, quantity: 2, supportedValues: "count" },
  videos: { enabled: false, quantity: 0, supportedValues: "count" },
  collateral: { enabled: false, quantity: 0, supportedValues: "count" },
  leadScanning: { enabled: true, quantity: "yes", supportedValues: "yes,no" },
  promotionalBanner: { enabled: false, quantity: "no", supportedValues: "yes,no" },
  inquiries: { enabled: false, quantity: "no", supportedValues: "yes,no" },
});
